import React, { FC } from 'react'
import { PlainContentWrapper } from './styles'
import { PlainContentProps } from './types'

const PlainContent: FC<PlainContentProps> = ({ content, noMargin }) => {
  return <PlainContentWrapper noMargin={!!noMargin} dangerouslySetInnerHTML={{ __html: content }} />
}

export default PlainContent
